import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import useStore from '../../../store';
import { IServerErrorResponse } from '../../../types';

export interface Institution {
  achEligible: boolean;
  checkEligible: boolean;
  city: string;
  countryCode: string;
  createdAt: string;
  fullName: string;
  phoneNumber: string;
  realtimeEligible: boolean;
  routingNumber: string;
  routingNumberType: string;
  shortName: string;
  state: string;
  streetAddress: string;
  updatedAt: string;
  wireEligible: boolean;
  wireSettlementOnly: boolean;
  zipCode: string;
  usedSwiftCode:string;
}

export const useGetSwiftData = (onError: (errMsg: string) => void) => {
  const { user: { customerId }, getPersonalAccount } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();
  return useMutation(
    'useGetSwiftData',
    async (swiftCode: string) => {
      const { data } = await httpService.get(`/api/v1/user/${customerId}/${accountExternalId}/international/wire/out/institution/${swiftCode}`);
      data.usedSwiftCode = swiftCode;
      return data as Institution;
    },
    {
      onError: (e: IServerErrorResponse) => {
        onError(e?.response?.data?.errors?.[0]?.localizedMessage || '');
      },
    },
  );
};
